import { useEffect, useState } from "react";

const useMultiStep = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const next = () => {
    setCurrentStep(currentStep + 1);
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const getStatus = (stepKey) => {
    if (stepKey < currentStep) return "finish";
    else if (stepKey == currentStep) return "process";
    else return "wait";
  };

  return { currentStep, setCurrentStep, next, prev, getStatus };
};

export default useMultiStep;
